// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StreamerMeta__container-d2b307 {
  position: absolute;
  inset-inline-end: 4px;
  display: flex;
  overflow: hidden;
  align-items: center;
}

.StreamerMeta__minimize-ac5f3f {
  inset-inline-start: 4px;
  top: 4px;
  inset-inline-end: 4px;
}

.StreamerMeta__meta-group-f76d46 {
  background-color: var(--addition-110_70);
  border-radius: 13px;
  padding: 0 8px;
  display: flex;
  overflow: hidden;
  flex: 0 1 auto;
  align-items: center;
  height: 26px;
  margin-inline-start: 8px;
}

.StreamerMeta__meta-group-f76d46:last-child {
  margin-inline-end: 0;
}

.StreamerMeta__name-f30e29 {
  flex: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 6px;
  font: var(--font-subtitle-3);
  color: var(--addition-50);
}

.StreamerMeta__name-f30e29:last-child {
  margin-inline-end: 0;
}

.StreamerMeta__muted-a0c25c {
  flex: 0 0 auto;
  fill: var(--addition-50);
}

.StreamerMeta__audio-state-header-a4cea0 {
  flex: 0 0 auto;
}

.StreamerMeta__audio-state-f4c03f {
  position: absolute;
  inset-inline-end: 4px;
  bottom: 4px;
  --muted-container-background-color: var(--addition-110);
  --muted-icon-fill-color: var(--addition-50);
}

.StreamerMeta__raise-hand-ba781d {
  border-radius: 50%;
  background-color: var(--addition-50);
  flex: 0 0 auto;
}

.StreamerMeta__active-f67018 {
  margin: 0;
}

.StreamerMeta__sharing-icon-c134ed {
  border-radius: 50%;
  background-color: var(--addition-110_70);
  fill: var(--base-120);
  padding: 4px;
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/StreamerMeta/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,QAAA;EACA,qBAAA;AACF;;AAEA;EACE,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,OAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uDAAA;EACA,2CAAA;AACF;;AAEA;EACE,kBAAA;EACA,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,wCAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  inset-inline-end: 4px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n}\n\n.minimize {\n  inset-inline-start: 4px;\n  top: 4px;\n  inset-inline-end: 4px;\n}\n\n.meta-group {\n  background-color: var(--addition-110_70);\n  border-radius: 13px;\n  padding: 0 8px;\n  display: flex;\n  overflow: hidden;\n  flex: 0 1 auto;\n  align-items: center;\n  height: 26px;\n  margin-inline-start: 8px;\n}\n\n.meta-group:last-child {\n  margin-inline-end: 0;\n}\n\n.name {\n  flex: 1;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 6px;\n  font: var(--font-subtitle-3);\n  color: var(--addition-50);\n}\n\n.name:last-child {\n  margin-inline-end: 0;\n}\n\n.muted {\n  flex: 0 0 auto;\n  fill: var(--addition-50);\n}\n\n.audio-state-header {\n  flex: 0 0 auto;\n}\n\n.audio-state {\n  position: absolute;\n  inset-inline-end: 4px;\n  bottom: 4px;\n  --muted-container-background-color: var(--addition-110);\n  --muted-icon-fill-color: var(--addition-50);\n}\n\n.raise-hand {\n  border-radius: 50%;\n  background-color: var(--addition-50);\n  flex: 0 0 auto;\n}\n\n.active {\n  margin: 0;\n}\n\n.sharing-icon {\n  border-radius: 50%;\n  background-color: var(--addition-110_70);\n  fill: var(--base-120);\n  padding: 4px;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StreamerMeta__container-d2b307`,
	"minimize": `StreamerMeta__minimize-ac5f3f`,
	"meta-group": `StreamerMeta__meta-group-f76d46`,
	"metaGroup": `StreamerMeta__meta-group-f76d46`,
	"name": `StreamerMeta__name-f30e29`,
	"muted": `StreamerMeta__muted-a0c25c`,
	"audio-state-header": `StreamerMeta__audio-state-header-a4cea0`,
	"audioStateHeader": `StreamerMeta__audio-state-header-a4cea0`,
	"audio-state": `StreamerMeta__audio-state-f4c03f`,
	"audioState": `StreamerMeta__audio-state-f4c03f`,
	"raise-hand": `StreamerMeta__raise-hand-ba781d`,
	"raiseHand": `StreamerMeta__raise-hand-ba781d`,
	"active": `StreamerMeta__active-f67018`,
	"sharing-icon": `StreamerMeta__sharing-icon-c134ed`,
	"sharingIcon": `StreamerMeta__sharing-icon-c134ed`
};
module.exports = ___CSS_LOADER_EXPORT___;
